import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsletterForm = ({ testId = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/leads/newsletter`, { email });
      setDone(true);
      toast.success("Subscribed. Welcome to The Signal.");
    } catch {
      toast.error("Subscription failed. Check your email and try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div data-testid={`${testId}-success`} className="flex items-center gap-3 border border-cyan-500/40 bg-cyan-500/10 px-5 py-4">
        <Check size={16} className="text-cyan-600" />
        <span className="font-mono text-xs uppercase tracking-[0.15em] text-cyan-600">Subscribed</span>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="flex w-full max-w-md">
      <input
        data-testid={`${testId}-email-input`}
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="work email"
        className="w-full border border-zinc-900/20 border-r-0 bg-transparent px-4 py-3.5 font-mono text-sm text-zinc-900 placeholder:text-zinc-400 focus:border-cyan-500 focus:outline-none"
      />
      <button data-testid={`${testId}-submit-btn`} type="submit" disabled={loading} className="btn-primary !px-5 !py-3.5 shrink-0">
        {loading ? "…" : <ArrowRight size={16} />}
      </button>
    </form>
  );
};

export default NewsletterForm;
